// src/components/blog/BlogQuote.jsx
import React from "react";

export default function BlogQuote({ text }) {
	return (
		<blockquote className="border-l-4 border-[#43bd98] pl-6 italic text-lg text-gray-700 bg-gray-50 rounded-md py-4 px-6 my-8 shadow-sm">
			{`“${text}”`}
		</blockquote>
	);
}
